/* eslint-disable import/prefer-default-export, no-unused-vars */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const waitlistRequest = makeEntityScaffold(
  'SAGA.API.JOIN_WAITLIST',
  (client, params = {}, key = 'default') => client.waitlist.create(params),
  { defaultKey: 2 }
);
